import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
//import {  RECAPTCHA_LANGUAGE,  RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { getSecureItem, setSecureItem } from "../src/app/pages/Services/secure-storage";

// let lang = JSON.parse(getSecureItem("selectedLang"));
let lang;
if (getSecureItem("selectedLang") && IsJsonString(getSecureItem("selectedLang"))){
  lang = JSON.parse(
    getSecureItem("selectedLang")
  );
} else {
  lang = {
      "langId": 1,
      "shDescNbr": null,
      "lgDescNbr": 29946,
      "used": true,
      "validated": true,
      "description": "English",
      "fileName" : "",
      "languagecode": "en"   
  };
  setSecureItem(
    "selectedLang",
    JSON.stringify(lang)
  );
}

if (environment.production) {
  enableProdMode();
}

fetch("/assets/json/config/"+environment.CONFIG_FILE_NAME+".json")
.then((data) => data.json())
.then(res=>{
 // const siteKey = res["EvoPortal"]["SITE_KEY_V3"];
  const langId = lang && lang.languagecode;
  //platformBrowserDynamic([
  //   {
  //   provide:RECAPTCHA_V3_SITE_KEY,useValue:siteKey
  //   },
  //   {
  //     provide: RECAPTCHA_LANGUAGE,
  //     useValue: langId, 
  //   },
  // ])
   platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
})



function IsJsonString(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}